// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { loginToAccessAlertStyles } from "@steiner/App/Components/LoginToAccessAlert/LoginToAccessAlert";
import { getNotifyStyle } from "@steiner/App/Components/Notify";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { mergeWithCss } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

loginToAccessAlertStyles.container = {
    ...mergeWithCss(getNotifyStyle("warning"), {
        css: css`
            flex-wrap: nowrap;
            align-items: flex-start;
            max-width: 100%;
            margin-bottom: 20px;
        `,
    }),
};

loginToAccessAlertStyles.message = {
    size: 14,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
    `,
};
loginToAccessAlertStyles.secondPartMessage = {
    forwardAs: "p",
    css: css`
        letter-spacing: 0;
        margin-top: 16px;
    `,
};

loginToAccessAlertStyles.viewLink = {
    typographyProps: {
        size: 14,
    },
    css: css`
        @media print {
            // STR-2589 - using important to override the global display: none !important;
            display: inline-block !important;
        }
    `,
};
